import { render } from "./OpenSeaDragonViewer.vue?vue&type=template&id=628e6f8f&ts=true"
import script from "./OpenSeaDragonViewer.vue?vue&type=script&lang=ts"
export * from "./OpenSeaDragonViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__